import facebookIcon from '../../images/socialNetworks/facebook.svg'
import instagramIcon from '../../images/socialNetworks/instagram.svg'
import spotifyIcon from '../../images/socialNetworks/spotify.svg'
import twitterIcon from '../../images/socialNetworks/twitter.svg'
import youtubeIcon from '../../images/socialNetworks/youtube.svg'

const title = 'Acompanhe a'

const titleSpan = 'tag'

const items = [
  {
    'alt': 'Facebook',
    'id': 1,
    'src': facebookIcon,
    'url': 'https://www.facebook.com/taglivros',
  },
  {
    'alt': 'Instagram',
    'id': 2,
    'src': instagramIcon,
    'url': 'https://www.instagram.com/taglivros',
  },
  {
    'alt': 'Twitter',
    'id': 3,
    'src': twitterIcon,
    'url': 'https://twitter.com/taglivros',
  },
  {
    'alt': 'Youtube',
    'id': 4,
    'src': youtubeIcon,
    'url': 'https://www.youtube.com/channel/UCm5f77q61g47CIOGGTpZJkA',
  },
  {
    'alt': 'Spotify',
    'id': 5,
    'src': spotifyIcon,
    'url': 'https://open.spotify.com/show/526y0je0waQswCiq7mghAG?si=_fHTikXwTOWJLdQq33hxuA',
  }
]
// eslint-disable-next-line
export default {
  items,
  title,
  titleSpan
}
